import { FunctionComponent, PropsWithChildren } from 'react';

interface LoginLayoutBodyProps extends PropsWithChildren {}

const LoginLayoutBody: FunctionComponent<LoginLayoutBodyProps> = ({ children }) => {
  return <div className="flex flex-col items-center justify-center h-full">{children}</div>;
};

export default LoginLayoutBody;
